export const SCHEDULE_APPOINTMENT_START = 'SCHEDULE_APPOINTMENT_START';

export const SCHEDULE_APPOINTMENT_SUCCESS = 'SCHEDULE_APPOINTMENT_SUCCESS';

export const SCHEDULE_APPOINTMENT_FAILED = 'SCHEDULE_APPOINTMENT_FAILED';
